<div *ngIf="show" class="overlay">
    <i class="fa fa-spinner fa-5x fa-spin"></i>
</div>
<!-- <div *ngIf="show" class="overlay">
  <i class="fa fa-spinner fa-spin"></i>
</div> -->
